import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  num: '01',
  title: 'Diagnóstico Total',
  desc: 'Checklists y test de compromiso real (con puntuación) para saber exactamente dónde estás parada sin autoengaños.'
}, {
  num: '02',
  title: 'La Verdad Incómoda',
  desc: 'Las 3 razones reales por las que algunas relaciones no avanzan y la lista negra de lo que nunca debes hacer.'
}, {
  num: '03',
  title: 'Reprogramación de Alto Valor',
  desc: 'Ejercicios para elevar tu estándar, dejar de sobreentregar y fortalecer tu amor propio desde adentro.'
}, {
  num: '04',
  title: '12 Scripts Exactos',
  desc: 'Palabras exactas para tener la conversación de claridad: qué decir, cómo decirlo y cómo responder a las evasivas.'
}, {
  num: '05',
  title: 'Retirada Estratégica',
  desc: 'El plan de 14 días para recuperar tu poder, tu misterio y tu energía sin manipulación y sin drama.'
}, {
  num: '06',
  title: 'Decisión en 30 Días',
  desc: 'Una hoja de ruta clara para pasar del diagnóstico a la decisión final: compromiso real o libertad con dignidad.'
}];
export function SolutionSection() {
  return <section className="py-10 md:py-14 px-6 bg-cream relative" data-id="element-218">
      <div className="max-w-5xl mx-auto" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-220">
          <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-221">
            La solución
          </p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4" data-id="element-222">
            Un método claro, práctico y<br className="hidden md:block" data-id="element-223" />
            <span className="text-burgundy" data-id="element-224"> brutalmente honesto</span>
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto font-serif italic" data-id="element-225">
            No más esperar. No más rogar. Solo claridad, estrategia y alto
            valor.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-10 md:gap-y-6" data-id="element-226">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-5 group" data-id="element-227">
              <div className="flex-shrink-0 text-2xl md:text-4xl font-serif font-bold text-gold/30 group-hover:text-gold transition-colors duration-300" data-id="element-228">
                {feature.num}
              </div>
              <div data-id="element-229">
                <h3 className="text-lg font-bold text-burgundy mb-1 font-serif" data-id="element-230">
                  {feature.title}
                </h3>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-231">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}